import React from 'react';
import moment from 'moment';
import { Typography } from '@mui/material';
import { useShowContext } from 'framework/show';
import { DATE_FORMAT } from 'framework/utils';

type Props = {
  source: string;
  sx?: object;
};

const AcceptanceArtifactDateField = ({ source, sx }: Props) => {
  const { data } = useShowContext();
  const value = data?.getValueBySource?.(source) as string | undefined;
  const formatted = value && moment(value).isValid() ? moment(value).format(DATE_FORMAT.API_ONLY_DATE) : '—';

  return (
    <Typography component="span" color="textSecondary" sx={{ ...sx }}>
      {formatted}
    </Typography>
  );
};

export default AcceptanceArtifactDateField;
